import https from '../init/https';

//INFO-01 : Get routes to fetch the details of a trip/ayur pack/guid pack/camp for user based on
//the id of the package
export async function getDetailsFun(type, packId) {
    const result = await https.get(`info/pack-info/${type}/${packId}`);
    return result;
}

//INFO-02 : To get basic information of the organizer
export async function orgBasicFun(type, orgId) {
    const result = await https.get(`info/org/${type}/${orgId}`);
    return result;
}

//INFO-03 : To get the total count of different trip/ayur/guid
//packages for a particular organizer
export async function packCountOrgFun(type, orgId) {
    const result = await https.get(`info/pack/count/${type}/${orgId}`);
    return result;
}

//INFO-04 : To get basic information of the organizer
export async function orgPacksFun(type, orgId, limit, offset) {
    const result = await https.get(`info/pack/${type}/${orgId}?limit=${limit}&offset=${offset}`);
    return result;
}

//INFO-05 : To get trip Date details
export async function getDateDetailsFun(type, packId) {
    const result = await https.get(`info/date/${type}/${packId}`);
    return result;
}

//INFO-06 : To get Faq count details
export async function getFaqCountFun() {
    const result = await https.get('/info/faq/count');
    return result;
}

//INFO-07 : To get Faq details
export async function getFaqDetailsFun(limit, offset) {
    const result = await https.get(`/info/faq?limit=${limit}&offset=${offset}`);
    return result;
}

//INFO-08 : To get Offer details
export async function getOfferDetailsFun(type, offerCode, offerData) {
    const result = await https.post(`/info/offer/${offerCode}?type=${type}`, offerData);
    return result;
}

//INFO-09 : To get Filter details
export async function getFilterDetailsFun(type) {
    const result = await https.get(`/info/filter/dropdowns/${type}`);
    return result;
}

//INFO-10 - Dropdowns for organizers
export async function getDropdownFun(type, dropKey) {
    const result = await https.get(`/info/dropdown/${type}/${dropKey}`);
    return result;
}

//INFO-11 - Payment info
export async function getPaymentInfo(id) {
    const result = await https.get(`/info/payment/info/${id}`);
    return result;
}

//INFO-12 - Get reviews
export async function getReviewsData(type, packId, offset, limit) {
    const result = await https.get(`/info/reviews/org/${type}/${packId}?offset=${offset}&limit=${limit}`);
    return result;
}

// INFO-13 - Get trips that you might be interested in
export async function getInterestedTrips(type, packId) {
    const result = await https.get(`/info/realted/${type}/${packId}`);
    return result;
}
//INFO-14 Trip details page related trips for particular organizer
export async function getInterestedTripsOrg(type, orgId) {
    const result = await https.get(`/info/org/realted/${type}/${orgId}`);
    return result;
}

// INFO-15 Active Offer list
export async function getOffersData() {
    const result = await https.get(`/info/offer/list`);
    return result;
}

// INFO-17 Special Offer
export async function getSpecialOffer() {
    const result = await https.get(`/info/special-offers`);
    return result;
}

// INFO-18 Free rooms / tents of each unit of a camp for the picked dates
// -> { bookable, reason, nights, fewLeft, units: { [unitId]: count } }
export async function getCampAvailabilityFun(listingId, { checkin, checkout, pets = 0 }, config) {
    const params = new URLSearchParams({ checkin, checkout, pets: String(pets || 0) });
    const result = await https.get(`/info/camp/availability/${listingId}?${params}`, config);
    return result;
}
